import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IMicrosoftAuthState } from './microsoft-auth.types';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

export const state: IMicrosoftAuthState = {
  version: 1
};

const namespaced = true;

export const microsoftAuth: Module<IMicrosoftAuthState, IRootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
